<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn
        :menuid="menuid"
        @btnClick="btnClick"
        :btnLoading="btnLoading"
      ></menu-btn>
    </div> -->
    <div>
      <el-tabs v-model="activeName" type="card" >
        <el-tab-pane label="待结算" name="first">
          <settlementTab :activeName="activeName" />
        </el-tab-pane>
        <el-tab-pane label="业务结算未达" name="second">
          <ywyNotReached :activeName="activeName" />
        </el-tab-pane>
        <el-tab-pane label="已结算" name="third">
          <settledTab :activeName="activeName" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </Container>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
import MenuBtn from "../common/menuBtn";
import settlementTab from "./settlementTab";
import settledTab from "./settledTab";
import ywyNotReached from "./ywyNotReached";

export default {
  name: "ywyjx",
  data() {
    return {
      menuid: this.$route.query.menuid,
      btnLoading: false,
      activeName: "first",
      list: [],
    };
  },
  activated() {},
  components: { MenuBtn, settlementTab, settledTab, ywyNotReached},
  created() {
    this.$on("CLOSE", () => this.close());
  },
  mounted() {},
  watch: {},
  filters: {},
  methods: {
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "",
      });
    },
    btnClick(code) {
      this.$emit(code);
    },
  },
};
</script>

<style scoped>
</style>
